import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Zap } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/80 backdrop-blur-xl border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="relative">
              <Zap className="w-8 h-8 text-[#FF6600] fill-[#FF6600]" />
              <div className="absolute inset-0 blur-lg bg-[#FF6600] opacity-50"></div>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">Intellapoint</h1>
              <p className="text-[10px] text-gray-400 -mt-1">AI Intelligence to the point</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('agents')}
              className="text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium"
            >
              AI Agents
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className="text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium"
            >
              Security
            </button>
            <button
              onClick={() => scrollToSection('usecases')}
              className="text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium"
            >
              Use Cases
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF6600] hover:bg-[#FF8C42] text-white font-semibold px-6 py-2 rounded-lg transition-all duration-300 shadow-lg hover:shadow-[#FF6600]/50"
            >
              Book a Call
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 bg-black/95 backdrop-blur-xl rounded-lg p-6 border border-white/10">
            <button
              onClick={() => scrollToSection('agents')}
              className="block w-full text-left text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium py-2"
            >
              AI Agents
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className="block w-full text-left text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium py-2"
            >
              Security
            </button>
            <button
              onClick={() => scrollToSection('usecases')}
              className="block w-full text-left text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium py-2"
            >
              Use Cases
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-gray-300 hover:text-[#FF6600] transition-colors duration-200 font-medium py-2"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#FF6600] hover:bg-[#FF8C42] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300"
            >
              Book a Call
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
